var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66538 8.23657L7.19747 6.951L8.48304 8.48309L11.5472 5.91194L12.8328 7.44402L8.23653 11.3007L5.66538 8.23657Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2071 2.89344C17.0923 5.77862 17.313 10.3193 14.8693 13.4578C14.8846 13.4713 14.8996 13.4854 14.9142 13.5L19.1569 17.7427C19.5474 18.1332 19.5474 18.7664 19.1569 19.1569C18.7663 19.5474 18.1332 19.5474 17.7426 19.1569L13.5 14.9143C13.4854 14.8996 13.4713 14.8846 13.4577 14.8693C10.3192 17.3131 5.77858 17.0923 2.8934 14.2071C-0.230794 11.083 -0.230794 6.01763 2.8934 2.89344C6.01759 -0.230756 11.0829 -0.230756 14.2071 2.89344ZM12.7929 12.7929C15.136 10.4498 15.136 6.6508 12.7929 4.30765C10.4497 1.96451 6.65076 1.96451 4.30761 4.30765C1.96447 6.6508 1.96447 10.4498 4.30761 12.7929C6.65076 15.1361 10.4497 15.1361 12.7929 12.7929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b407a8a4231d7c8f1c77ae62370f24fd.svg";
export { ForwardRef as ReactComponent };